import React, { useState, useEffect } from "react";
import Footer from "components/Footer/Footer";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UpcomingEvents from "components/UpcomingEvents/UpcomingEvents";
import axios from "axios";
import _get from "lodash/get";
import TitleSection from "components/TitleBar/TitleSection";
import PresentationCard from "components/PresentationCard/PresentationCard";
import {
  dateConvert,
  unixDateConversion,
  DaysDiff,
  HoursDiff,
} from "utils/Helper";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import {
  org_friendly_url,
  organization_user_access_level,
  owner_perms,
  myHeaders_With_Cache_Control,
  myHeaders_Auth_With_Cache_Control,
  user_entity_uuid,
  apiUrl,
  HeaderConfig,
  channel_list_api,
  searchUrl,
  presentation_Creation_API,
  user_Status,
  myHeaders_Autorized,
  user_access_level,
} from "Api/Api";
import SpotLightPk from "components/spotlightedPK/spotlightedPK";
import { local_routes } from "utils/Routes";
import { NavLink } from "react-router-dom";
import Button from "components/Button/Button";
import home from "Assets/home.svg";
import { current_unix_stamp } from "utils/Helper";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";

const ChannelDetails = (props) => {
  const [show_edit_button, set_show_edit_button] = useState(false);
  const [channel_uuid, set_channel_uuid] = useState("");
  const [page_loader, set_page_loader] = useState(true);
  const [logo_image_url, set_logo_image_url] = useState("");
  const [description, set_description] = useState("");
  const [trending_pk_inc, set_trending_pk_inc] = useState([]);
  const [video_info, set_video_info] = useState({});
  const [entity_name, set_entity_name] = useState("");
  const [presentation_data, set_presentation_data] = useState({});
  const [like_loader, set_like_loader] = useState(false);
  const [label_like, set_label_like] = useState("like");
  const [applaud_count, set_applaud_count] = useState(0);
  const [pk_entity_uuid, set_pk_entity_uuid] = useState(null);
  const [presentation_detail, set_presentation_detail] = useState([]);
  const [like_count, set_like_count] = useState(0);
  const [all_event_arr, set_all_event_arr] = useState([]);
  const [load_more_loader, set_load_more_loader] = useState(false);
  const [channel_info, set_channel_info] = useState({});
  const [channel_name, set_channel_name] = useState("");
  const [from, set_from] = useState(0);
  const [limit, set_limit] = useState(3);
  const [got_all_all, set_got_all_all] = useState(false);

  let workspace_base_url = "";
  let Channel_or_Team = "Channel";
  let channel_or_team = "channel";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
    local_routes.managechannel = local_routes.manageteam;
    local_routes.channels = local_routes.teams;
    Channel_or_Team = "Team";
    channel_or_team = "team";
  }

  const showMoreEvents = (past_or_future, from, limit) => {
    set_load_more_loader(true);
    showEvents(channel_info, past_or_future, from, limit);
  };

  // see all events
  const showEvents = async (channel_info, past_or_future, from, limit) => {
    let eventsData;
    let eventArr = [];
    let order;
    let start_or_end;
    let got_them_all = false;

    let query_params = {
      //start_time_order: order,
      channels_uuid: channel_info.entity_uuid,
      channels_text: channel_info.entity_name,
      from,
      limit
    }


    if (past_or_future === "future") {
      query_params.start_time_order = "ASC";
      query_params.search_start_time = current_unix_stamp;
    } else if (past_or_future === "past") {
      query_params.start_time_order = "DESC";
      query_params.search_end_time = current_unix_stamp;
    } else {
      query_params.start_time_order = "DESC";
    }

    eventsData = await axios.get(`${searchUrl}eventsearch`, { params: query_params });
    //eventsData = await axios.get(
    //  `${searchUrl}eventsearch?${start_or_end}start_time_order=${order}&channels_uuid=${channel_info.entity_uuid}&channels_text=${channel_info.entity_name}&from=${from}&limit=${limit}`,
    //  HeaderConfig
    //);

    if (
      !eventsData ||
      !eventsData.data ||
      !eventsData.data.search_query_results ||
      eventsData.data.search_query_results.length < limit
    ) {
      got_them_all = true;
    }

    if (
      eventsData.data &&
      eventsData.data.search_query_results &&
      eventsData.data.search_query_results.length > 0
    ) {
      for (let item of eventsData.data.search_query_results) {
        let entity = item.entity_info;

        let venues_data = "";
        const start_time = unixDateConversion(entity.start_time);
        const start_time_conv = dateConvert(start_time);
        let time_slot = start_time_conv.hour;
        var selectedDate = start_time;

        let days_left;
        if (selectedDate > new Date()) {
          let day_diff = DaysDiff(start_time);
          let hour_diff = HoursDiff(start_time);
          days_left =
            "Starts in " + day_diff + " days, " + hour_diff + " hours";
        } else {
          days_left = "Completed";
        }

        eventArr.push({
          entity_name: entity.entity_name,
          friendly_url: entity.friendly_url,
          entity_uuid: entity.entity_uuid,
          event_days_left: days_left,
          thumb_image_url: entity.thumb_image_url || null,
          poster_image_url: entity.poster_image_url,
          locations_text: entity.locations_text,
          Event_month: start_time_conv.month,
          Event_year: start_time_conv.year,
          Event_day: start_time_conv.day,
          Event_date: start_time_conv.date,
          Event_slot: time_slot,
          volume_integer: entity.volume_integer,
          Events_venue: venues_data,
        });
      }
    }

    let new_limit = limit * 4;
    if (new_limit > 200) {
      new_limit = 200;
    }
    let new_from = from + limit;

    set_load_more_loader(false);
    set_got_all_all(got_them_all);
    set_from(new_from);
    set_limit(new_limit);
    set_all_event_arr(all_event_arr.concat(eventArr));
  };

  useEffect(() => {
    let {
      location: { pathname },
    } = props;

    routeChanged();
  }, [props.location.pathname]);

  const routeChanged = () => {
    set_from(0);
    set_limit(3);
    set_all_event_arr([]);

    APICalls();
  };

  useEffect(() => {
    routeChanged();
  }, []);

  // Api Calling starts
  const APICalls = async function () {
    window.scrollTo(0, 0);
    set_page_loader(true);
    const { match } = props;
    friendlyUrl = _get(match, "params.friendly_url", "").toLowerCase();

    // Show edit button?
    let allowed = false;
    if (user_access_level === "admin") {
      allowed = true;
    }
    if (organization_user_access_level === "admin") {
      allowed = true;
    }
    if (
      owner_perms["channels"] &&
      owner_perms["channels"][friendlyUrl] &&
      owner_perms["channels"][friendlyUrl] === "admin"
    ) {
      allowed = true;
    }
    console.log("ChannelDetail componentDidMount allowed", allowed);
    if (allowed) {
      set_show_edit_button(true);
    }

    // ChannelDetail banner Data api
    const channelData = await axios.get(
      `${channel_list_api}/${friendlyUrl}`,
      HeaderConfig
    );
    set_channel_info(channelData.data);

    const channel_name = _get(channelData, "data.entity_name", "");
    const channel_uuid = _get(channelData, "data.entity_uuid", "");

    showEvents(channelData.data, "all", from, limit);

    // ChannelDetail Trending Pks Data api
    function channelVideoData() {
      return axios.get(
        `${channel_list_api}/${friendlyUrl}/presentations?do_recursive=true&sort_obj=${encodeURIComponent(
          '{"spotlighted_time":"desc"}'
        )}&limit=1`,
        HeaderConfig
      );
    }
    // ChannelDetail Video Data api
    function channelTrendingPkData() {
      return axios.get(
        `${searchUrl}presentationsearch?get_presenter=true&channels_uuid=${channel_uuid}&channels_text=${friendlyUrl}&sort_by=created_time&sort_order=DESC`,
        HeaderConfig
      );
    }
    // Calling all API's using axios.all method
    axios
      .all([channelVideoData(), channelTrendingPkData()])
      .then(
        axios.spread((channelVideo_res, channelPks_res) => {
          set_logo_image_url(channelData.data.logo_image_url);
          set_description(channelData.data["description"]);
          set_entity_name(channelData.data.entity_name);

          // Video Data
          const videoInfo = {};
          let presentationData = {};
          if (channelVideo_res.data && channelVideo_res.data.length) {
            const data = channelVideo_res.data[0];
            videoInfo.presentation_video_url = data.presentation_video_url;
            videoInfo.applaud_count = data.applaud_count;
            videoInfo.entity_name = data.entity_name;
            videoInfo["description"] = data["description"];
            videoInfo.friendly_url = data.friendly_url;
            videoInfo.entity_uuid = data.entity_uuid;

            set_pk_entity_uuid(data.entity_uuid);
            set_like_count(videoInfo.applaud_count);

            channelVideo_res.data.forEach((element) => {
              if (element.users && element.users.length > 0) {
                element.users.forEach((item) => {
                  if (item.xref_data && item.xref_data.presenter_integer >= 1) {
                    if (item !== undefined) {
                      presentationData.avatar_image_url = item.avatar_image_url;
                      presentationData["description"] = item["description"];
                      presentationData.firstname = item.firstname;
                      presentationData.lastname = item.lastname;

                      if (item.firstname && item.lastname) {
                        item.full_name = item.firstname + " " + item.lastname;
                      } else if (element.lastname) {
                        item.full_name = item.lastname;
                      } else if (element.firstname) {
                        item.full_name = item.firstname;
                      } else {
                        item.full_name = "Unknown";
                      }
                      presentationData.full_name = item.full_name;

                      if (item.status_code === 1 && item.friendly_url) {
                        presentationData.presenter_friendly_url =
                          item.friendly_url;
                      } else {
                        presentationData.presenter_friendly_url = "";
                      }
                    }
                  }
                });
              }
            });
          }
          set_video_info({ ...videoInfo });
          // Tranding Pks
          if (channelPks_res.data.search_query_results.length !== 0) {
            let managedContentsPkArr = [];
            channelPks_res.data.search_query_results.forEach((item) => {
              managedContentsPkArr.push(item);
            });
            set_trending_pk_inc(managedContentsPkArr);
          }
          // User API Promises
          if (user_Status === 1) {
            let audience_params = {
              attributes: ['entity_uuid']
            };
            Promise.all([
              axios.get(
                `${apiUrl}users/${user_entity_uuid}/presentations.audience`,
                { params: audience_params, ...myHeaders_Autorized }
              ),
            ]).then(([likeDataApiRes]) => {
              if (likeDataApiRes.data) {
                let tmp_label = "like";
                for (let element of likeDataApiRes.data) {
                  if (element.entity_uuid === videoInfo.entity_uuid) {
                    if (
                      element.xref_data &&
                      element.xref_data.applauded_time &&
                      element.xref_data.applauded_time > 0
                    ) {
                      tmp_label = "unlike";
                      break;
                    }
                  }
                }
                set_label_like(tmp_label);
                return;
              }
            });
          }
          // User API Promises End
          // Like and Unlike Api Data
          if (pk_entity_uuid !== null && pk_entity_uuid !== undefined) {
            axios
              .get(
                `${presentation_Creation_API}/${pk_entity_uuid}`,
                HeaderConfig
              )
              .then((presentationRes) => {
                if (presentationRes.data) {
                  set_presentation_detail(presentationRes.data);
                  set_applaud_count(presentationRes.data.applaud_count);
                  axios.post(
                    `${presentation_Creation_API}/${presentationRes.data.entity_uuid}/incrementCount?count_type=view`,
                    {},
                    HeaderConfig
                  );
                }
              });
          }

          set_page_loader(false);
          set_channel_name(channel_name);
          set_channel_uuid(channelData.data.entity_uuid);
          set_presentation_data(presentationData);
        })
      )
      .catch(() => {
        set_page_loader(false);
      });
  };
  // Api Calling Ends

  // Like And Unlike Method
  const handleClickLike = () => {
    if (user_Status === 1) {
      set_like_loader(true);
      let decrement_flag = "";
      let new_label = "unlike";
      if (label_like === "unlike") {
        decrement_flag = "&decrement=true";
        new_label = "like";
      }
      axios
        .post(
          `${presentation_Creation_API}/${presentation_detail.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`,
          {},
          myHeaders_Autorized
        )
        .then((res) => {
          if (
            res.data.message ===
            "count not incremented - user has already done this action"
          ) {
            set_like_loader(false);
            return null;
          }
          set_like_count(res.data.new_count);
          set_label_like(new_label);
          set_like_loader(false);

          let audience_params = {
            attributes: ['entity_uuid']
          };

          axios.all([
            axios.get(
              `${channel_list_api}/${
                props.match.params.friendly_url
              }/presentations?do_recursive=true&sort_obj=${encodeURIComponent(
                '{"spotlighted_time":"desc"}'
              )}&limit=1`,
              myHeaders_With_Cache_Control
            ),
            axios.get(
              `${apiUrl}users/${user_entity_uuid}/presentations.audience`,
              { params: audience_params, ...myHeaders_Auth_With_Cache_Control }
            ),
          ]);
        });
    }
  };
  const UpcomingEventsListChip = (eventArr) => {
    return (
      <Row>
        {eventArr.map((item) => (
          <Col lg={4} key={item.entity_uuid}>
            <UpcomingEvents
              Event_year={item.Event_year}
              key={item.entity_uuid}
              id={item.entity_uuid}
              Event_img={item.thumb_image_url || item.poster_image_url}
              Event_time={item.event_days_left}
              Event_month={item.Event_month}
              Event_date={item.Event_date}
              Event_title={item.entity_name}
              Event_vol={item.volume_integer}
              Event_slot={item.Event_slot}
              Event_venues={item.Events_venue}
              Event_link={`${workspace_base_url}${local_routes.events}/${item.friendly_url}`}
            />
          </Col>
        ))}
      </Row>
    );
  };

  const userPresentations = () => {
    return (
      <Row>
        {trending_pk_inc.map((item) => (
          <Col key={item.entity_info.entity_uuid} lg={4} sm={12} md={6}>
            <PresentationCard
              key={item.entity_info.entity_uuid}
              presentation_info={item.entity_info}
            />
          </Col>
        ))}
      </Row>
    );
  };

  const { match } = props;
  let friendlyUrl = _get(match, "params.friendly_url", "").toLowerCase();

  if (page_loader) {
    return <FullPageSpinner />;
  } else {
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>{entity_name} Presentations & 20x20 Pecha Kuchas</title>
          <meta
            name="description"
            content={`The most immersive and informative ${entity_name} presentations on the internet. All in 20x20 Pecha Kucha format.`}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`https://www.pechakucha.com${local_routes.channels}/${friendlyUrl}`}
          />
          <meta
            property="og:title"
            content={`${entity_name} Presentations & 20x20 Pecha Kuchas`}
          />
          <meta
            property="og:description"
            content={`The most immersive and informative ${entity_name} presentations on the internet. All in 20x20 Pecha Kucha format.`}
          />
        </Helmet>
        <div className="">
          <div className="container">
            {/* Banner Part Starts here */}
            {logo_image_url && description !== undefined && !null ? (
              <div>
                <div className="channelsDetail">
                  <Row className="align-items-center">
                    <Col lg={5} md={12}>
                      <div className="instituteLogo">
                        <img
                          src={logo_image_url}
                          className="img-fluid"
                          alt="img"
                        ></img>
                      </div>
                    </Col>
                    <Col lg={7} md={12}>
                      <div className="instituteContent">
                        <h4>
                          <div
                            dangerouslySetInnerHTML={{ __html: description }}
                          />
                        </h4>
                      </div>
                    </Col>
                    <Col lg={12}>
                      {show_edit_button && (
                        <NavLink
                          to={`${workspace_base_url}${local_routes.managechannel}/${props.match.params.friendly_url}/main`}
                        >
                          <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                            Manage {Channel_or_Team}
                          </Button>
                        </NavLink>
                      )}
                    </Col>
                  </Row>
                  <Row></Row>
                </div>
                {all_event_arr.length > 0 && <hr />}
              </div>
            ) : null}
            {/* Banner Part Ends here */}
            {all_event_arr.length > 0 && (
              <div>
                <br />
                <Container>
                  {/* Recent and Upcoming Events starts */}

                  <TitleSection
                    title="Upcoming & Recent Events"
                    Title_link={local_routes.events}
                    seeAll="false"
                  />
                  {UpcomingEventsListChip(all_event_arr)}

                  {/* Recent and Upcoming Events Ends */}
                  {!got_all_all && (
                    <div>
                      {load_more_loader === true ? (
                        <ActivityIndicator theme="spinnerNoMargin" />
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: "20px",
                            color: "#fff",
                          }}
                        >
                          <a
                            onClick={() => showMoreEvents("all", from, limit)}
                            className="loadmore-btn"
                          >
                            Show More Events
                          </a>
                        </p>
                      )}
                    </div>
                  )}
                </Container>
                <br />
              </div>
            )}
          </div>

          {/* Channel Media Starts */}
          {video_info.presentation_video_url !== undefined && (
            <SpotLightPk
              city_or_channel_name={entity_name}
              presentation_data={video_info}
              entity_name={video_info.entity_name}
              avatar_image_url={presentation_data.avatar_image_url}
              firstName={presentation_data.firstname}
              lastName={presentation_data.lastname}
              designation={presentation_data["description"]}
              full_name={presentation_data.full_name}
              presenter_friendly_url={presentation_data.presenter_friendly_url}
              friendly_url={video_info.friendly_url}
              designation={presentation_data["description"]}
              description={video_info["description"]}
              mailTo="mailto:support@pechakucha.org"
              textReport=""
              iconName="fa fa-flag"
              iconNameLike="fa fa-heart"
              noOfLikes={like_count}
              handleClick={handleClickLike}
              likeLabel={label_like}
              likeLoader={like_loader}
              workspace_base_url={workspace_base_url}
            />
          )}
          {/* Channel Media Ends */}
          <div className="container">
            {trending_pk_inc.length > 0 && (
              <div className="channelsDetailPage">
                {/* Trending Pks for user starts */}
                <TitleSection
                  title={`Trending ${entity_name} Pks`}
                  Title_link="/pklist"
                  seeAll={trending_pk_inc.length > 0 ? "true" : "false"}
                />
                {userPresentations()}
                {/* Trending Pks Pks for user Ends */}
              </div>
            )}
          </div>
          <Footer
            homeImg={home}
            homeImgRef={workspace_base_url ? workspace_base_url : "/"}
            breadcrumbMainPage={`${Channel_or_Team}s`}
            breadcrumbSubPage={`${Channel_or_Team} Detail`}
            mainPageLink={workspace_base_url + "/" + channel_or_team + "s"}
          />
        </div>
      </React.Fragment>
    );
  }
};

export default ChannelDetails;
